import { UserManager, WebStorageStateStore} from "oidc-client-ts";
import { identityConfig, metaDataConfig } from "./authConst";
import { User } from "oidc-client";

export default class AuthService {
    userManager: any;
    static instance: any;
    user: any;

    constructor() {
        if (AuthService.instance) {
            return AuthService.instance;
        }

        // initialize UserManager instance
        this.user = null;
        AuthService.instance = this;

        this.userManager = new UserManager({
            ...identityConfig,
            userStore: new WebStorageStateStore({ store: window.sessionStorage }),
            metadata: {
                ...metaDataConfig,
            },
        });

        this.userManager.events.addUserLoaded((user: User) => {
            console.log("User loaded");
            if (window.location.href.indexOf("signin-oidc") !== -1) {
                this.navigateToScreen();
            }
        });
        this.userManager.events.addUserUnloaded(() => {
            console.log("User unloaded");
        });
        this.userManager.events.addUserSignedIn(() => {
            console.log("User signed In");
        });
        this.userManager.events.addUserSignedOut(() => {
            console.log("User signed Out");
        });
        this.userManager.events.addSilentRenewError((e: any) => {
            console.log("silent renew error", e.message);
        });
        this.userManager.events.addAccessTokenExpired(() => {
            console.log("Access token expired");
            this.logout();
        });
        this.userManager.events.addAccessTokenExpiring(() => {
            console.log("Access token expiring");
            this.logout();
        });
    }

    static getInstance() {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService();
        }
        return AuthService.instance;
    }

    signinRedirectCallback = () => {
        this.userManager.signinRedirectCallback().then(function (user: User) {
            window.history.replaceState({},
                window.document.title,
                window.location.origin + window.location.pathname);
            
        }).catch((err: any) => {
            console.log(err);
        });
    };

    getUser = async () => {
        const user: User = await this.userManager.getUser();
        if (!user) {
            return await this.userManager.signinRedirectCallback();
        }
        return user;
    };

    parseJwt = (token: any) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };

    signinRedirect = () => {
        localStorage.setItem("redirectUri", window.location?.pathname);
        this.userManager.signinRedirect({});
    };

    navigateToScreen = () => {
        window.location.replace("/");
    };

    isAuthenticated = () => {
        const item: string | null = sessionStorage.getItem(
            `oidc.user:${identityConfig.authority}:${identityConfig.client_id}`
        );
        const oidcStorage = item !=null ? JSON.parse(item): null;

        return !!oidcStorage && !!oidcStorage.access_token;
    };

    signinSilent = () => {
        this.userManager.signinSilent()
            .then((user: User) => {
                console.log("signed in", user);
            })
            .catch((err: any) => {
                console.log(err);
            });
    };
    signinSilentCallback = () => {
        this.userManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.userManager.createSigninRequest();
    };

    logout = () => {
        this.userManager.signoutRedirect({
            id_token_hint: localStorage.getItem("id_token"),
        });
        this.userManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        this.userManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
            window.location.replace("/");
        });
        this.userManager.clearStaleState();
    };
}
